(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var timer;

    function submitUpdate(form) {
      /* form.submit() sends no button name, so it updates the cart instead of going to checkout */
      form.submit();
    }

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var form = input.closest('[data-cart-form]');
      if (!form) return;
      if (input.value === '' || parseInt(input.value, 10) < 0) input.value = 0;
      clearTimeout(timer);
      timer = setTimeout(function () { submitUpdate(form); }, 500);
    });

    /* Enter in a quantity box should update the cart, not trigger the Check out button */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-cart-qty]');
      if (!input) return;
      e.preventDefault();
      var form = input.closest('[data-cart-form]');
      if (form) submitUpdate(form);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    /* Quantity +/- (delegated, works with ajax-replaced markup) */
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-qty]');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var val = parseInt(input.value, 10) || min;
      val = plus ? val + 1 : Math.max(min, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Gallery dots */
    function initGallery(media) {
      var gallery = media.querySelector('[data-gallery]');
      var dots = media.querySelectorAll('[data-dot]');
      var slides = media.querySelectorAll('[data-slide]');
      if (!gallery || !dots.length || media.dataset.ready) return;
      media.dataset.ready = 'true';

      function setActive(i) {
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.dataset.dot, 10);
          gallery.scrollTo({ left: slides[i].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(Array.prototype.indexOf.call(slides, entry.target));
            }
          });
        }, { root: gallery, threshold: 0.6 });
        slides.forEach(function (s) { io.observe(s); });
      } else {
        gallery.addEventListener('scroll', function () {
          setActive(Math.round(gallery.scrollLeft / gallery.clientWidth));
        }, { passive: true });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-product-media]').forEach(initGallery);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
